module.exports = __webpack_public_path__ + "img/16.c2a5225b.gif";